module.exports = __webpack_public_path__ + "static/media/SWSCRC6-22.053b06ed.mp3";